import React from "react";
//outsource
import { Row, Col, InputNumber, Form } from "antd";

//components

const IncomeGift = ({ edit, gift, setGift }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (value) => {
    setGift(value);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item initialValue={0} name="gift">
      <InputNumber
        min={0}
        value={gift}
        onChange={handleChange}
        prefix="$"
        disabled={!edit}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      />
    </Form.Item>
  );
};

export default IncomeGift;
